"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var ReceiptLineConverter_1 = require("./conversions/ReceiptLineConverter");

var ReceiptLineConverterImpl_1 = require("./conversions/ReceiptLineConverterImpl");
/**
 * @author VRu
 */


var ReceiptAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(ReceiptAppModule, _AppModule_1$AppModul);

  function ReceiptAppModule() {
    var _this;

    _classCallCheck(this, ReceiptAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReceiptAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'ReceiptAppModule';
    return _this;
  }

  _createClass(ReceiptAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(ReceiptLineConverter_1.ReceiptLineConverter).to(ReceiptLineConverterImpl_1.ReceiptLineConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return ReceiptAppModule;
}(AppModule_1.AppModule);

exports.ReceiptAppModule = ReceiptAppModule;